module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("BerlinFuchs (engl: BerlinFox) is an initiative by Berlin based student "), _c('b', [_vm._v("Britta Armstrong")]), _vm._v(" to help\n        handicapped people to find the place they need. The project is powered by\n        "), _c('b', [_vm._v("Google Maps")]), _vm._v(" and shows locations like schools, work oportunities, appartments and\n        free time/social activities.")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "info": "",
      "header": "Not yet finished",
      "color": _vm.project.color
    }
  }, [_c('p', [_vm._v("Due to lack of time the project is on ice right now."), _c('br'), _vm._v("\n        Since the website is riddled with bugs I have disabled the link to it for now.")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "What are you looking for?"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/projects/berlinfuchs/menu.jpg",
      "alt": "Navigation Menu"
    }
  }), _vm._v(" "), _c('p', [_vm._v("The menu holds 29 categories like kindergardens, work places separated for young and old\n        but also areas with good accessibility for wheelchairs.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/berlinfuchs/overlay-animation.mp4",
      "autoplay": "",
      "loop": ""
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Leads you all the way"
    }
  }, [_c('p', [_vm._v("Type in your address or let the app find you with the help of GPS to show\n        you the right way by car, foot, transit and bicycle.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/projects/berlinfuchs/directions.jpg",
      "alt": "Mobile View of the App"
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Easy to navigate on mobile"
    }
  }, [_c('p', [_vm._v("The map and direction navigation was inspired by the Google Maps website.\n        Therefore it is tested and works well on mobile.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/projects/berlinfuchs/mobile.jpg",
      "alt": "Mobile View of the App"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e85ea34"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/berlinfuchs.vue
// module id = 110
// module chunks = 0